<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconChevronUp_16"
    viewBox="0 0 16 16"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        d="M11.577 10.749 8 7.069l-3.577 3.68a.816.816 0 0 1-1.179 0 .874.874 0 0 1 0-1.212L7.411 5.25a.816.816 0 0 1 1.178 0l4.167 4.286a.873.873 0 0 1 0 1.212.816.816 0 0 1-1.179 0Z"
    />
</svg>
